var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter-selected",
    d: "M15,0H1A1,1,0,0,0,.294,1.707L6,7.414V13.25A1,1,0,0,0,6.342,14l2,1.749A1,1,0,0,0,10,15V7.414l5.706-5.707A1,1,0,0,0,15,0Z",
    transform: "translate(0)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-selected.e77e786d1636b626b8cc313b666346df.svg";